import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupService } from 'src/app/services/shared/popup.service';

@Component({
  selector: 'app-question-modal',
  templateUrl: './question-modal.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class QuestionModalComponent implements OnInit {
  @Input() displayType: string = '';
  constructor(private dialogRef: MatDialogRef<QuestionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private popupService: PopupService) {
    this.displayType = data.displayType
  }

  ngOnInit(): void {

  }
  Login() {
    this.CloseModal();
    this.popupService.openLoginModal();
  }

  Upgrade() {
    this.CloseModal();
    this.popupService.OpenPayingPlanPicker();
  }

  CloseModal() {
    this.dialogRef.close();
  }

}
